import { render, staticRenderFns } from "./PricelistDetail.vue?vue&type=template&id=7cae4cd2&"
import script from "./PricelistDetail.vue?vue&type=script&lang=ts&"
export * from "./PricelistDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports